import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { loginUser, logoutUser } from '../../../../action/AccountActions';

import CustomButton from '../../../CustomButton';
import { useAuth } from "../../../../../../context/AuthContext";

import '../../../dump/menuComponents/menuComponents.sass'

const LoginForm = (props) => {
	const navigate = useNavigate();
	const { login, logout } = useAuth();
	const [data, setData] = useState({
		email: '',
		password: '',
	})
	const [errMessage, setErrMessage] = useState({
		email: '',
		password: '',
	})
	const [toggle_password, setToggle_password] = useState(true)
	const [rememberMe, setRememberMe] = useState(1)

	useEffect(() => {
		setRememberMe(localStorage.getItem('r_u') === null ? 1 : localStorage.getItem('r_u') * 1);
	}, []);

	const togglePassword = () => {
		setToggle_password(!toggle_password);
	}

	const fillForm = ({ target }) => {
		const value = target.type === 'checkbox' ? target.checked : target.value;

		if (target.name === 'rememberMe') {
			setRememberMe(value * 1);
		} else {
			let dataUpdate = data;
			dataUpdate[target.name] = value;
			setData({ ...dataUpdate, [target.name]: value });
			setErrMessage({ ...errMessage, email: '', password: '' });
		}
	}

	const checkForm = (data) => {
		let error = false;
		const updatedErrMessage = { ...errMessage };

		for (const i in data) {
			if (data[i] == '') {
				error = true;
				updatedErrMessage[i] = 'Please enter your ' + i;
			}
			else if (errMessage[i]) {
				updatedErrMessage[i] = null;
			}
		}

		if (!updatedErrMessage.email) {
			var re = /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(data.email)) {
				error = true;
				updatedErrMessage.email = 'Please enter a valid email.';
			}
		}

		setErrMessage(updatedErrMessage);
		return error;
	}

	const sendForm = (e) => {
		e.preventDefault()

		const { toggleLoader } = props
		const error = checkForm(data)

		if (!error) {
			toggleLoader(true);

			loginUser(data)
				.then(async (res, err) => {
					if (res.data.response.error && res.data.response.error === 'you have to logout first') {
						logoutUser()
							.then(async (res, err) => {
								await logout();
								sendForm(e);
							})
							.catch((error) => {
								console.log('!error');
								console.log(error);
							});
					}
					else if (res.data.response.error && ['Invalid password', 'Specified user does not exist'].includes(res.data.response.error)) {
						toggleLoader(false)
						setErrMessage({ ...errMessage, password: 'Email/Password is incorrect. Please try again.' })
					}
					else if (res.data.response.error) {
						toggleLoader(false)
						toastr.error('Unable to login user. Please try again later');
					}
					else if (res.data.response.roles && res.data.response.roles[0] === 'notification_recipient') {
						toggleLoader(false);
						navigate('/confirmation');
					} else {
						// ToDo: Cognito - disable
						const { session_token } = res.data.response
						// const { auth_refresh_token, auth_token } = res.data.response;
						// await login({ auth_refresh_token, auth_token });
						await login({ session_token });
						toggleLoader(false)
						const { last_login } = res.data.response;
						if (!last_login) {
							navigate('/account/settings', {
								state: { status: 'firstly' },
							})
						} else {
							navigate('/', {
								replace: true,
							});
						}
					}
				})
				.catch((error) => {
					console.log(error.response);

					toggleLoader(false)

					if (error.response && error.response.data.response.error) {
						let error_content = error.response.data.response.error;
						let error_title = '';
						if (error_content.toLowerCase() === 'invalid password') {
							error_title = 'Please re-enter your password';
							error_content = 'The password you\'ve entered is incorrect, please try again. <br\><b>(Note: Password is case sensitive)</b><br\>Forgotten your password? <a href="/restore-password">Request a new one</a>';
						}
						else if (error_content.toLowerCase() === 'specified user does not exist') {
							error_title = 'Incorrect Email';
							error_content = 'The email you entered does not belong to any account. <br\> <a href="/login">Please try again</a>';
						}

						toastr.error(error_content);
					}
					else {
						toastr.error('Unable to login user. Please try again later');
					}
				});
		}
	}

	const { email, password } = errMessage;

	return (
		<div className="panel-body">
			<h3 className="login-header">Login:</h3>
			<div className="form-wrapper">

				<form onSubmit={sendForm} autoComplete={rememberMe ? 'auto' : 'off'} id="login-form">
					{!rememberMe && <input autoComplete="false" name="hidden" type="text" className="hidden" hidden="none" />}
					<div className='login-form'>
						<label className={`login-label ${(data.email.length) ? 'active' : ''}`}>E-mail</label>
						<input
							type="text"
							name="email"
							className={`vehicle-search ${(email || password) ? 'error' : ''}`}
							onChange={fillForm}
							placeholder="E-mail"
							autoComplete={rememberMe ? 'auto' : 'new-password'}
						/>
						{email && <span className="help-block error-label">{email}</span>}
					</div>
					<div className="login-form has-feedback">
						<label className={`login-label ${(data.password.length) ? 'active' : ''}`}>Password</label>
						<input
							type={toggle_password ? 'password' : 'text'}
							id="password"
							name="password"
							className={`vehicle-search ${password ? 'error' : ''}`}
							data-toggle="password"
							onChange={fillForm}
							placeholder="Password"
							autoComplete={rememberMe ? 'auto' : 'new-password'}
						/>
						<span className="fa fa-eye form-control-feedback" onClick={togglePassword} />
						{password && <span className="help-block error-label">{password}</span>}
					</div>
					<div className="login-form">
						<div className="checkbox">
							<label>
								<input
									type="checkbox"
									name="rememberMe"
									checked={rememberMe}
									onChange={fillForm}
								/>
								Remember Me
							</label>
						</div>
					</div>
					<div className="login-form submit-btn">
						<CustomButton variant="primary" type="submit" value="Login" id="login-button" style={{ padding: '8px 0px' }}>Login</CustomButton>
					</div>

					<div className="forgot-password">
						<Link to="/restore-password">Forgot password</Link>
					</div>
				</form>

			</div>
		</div>
	)
}

export default connect(
	null,
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(LoginForm)
